import styled, { css } from 'styled-components'
import media from 'styled-media-query'

export const QuestionWrapper = styled.div`
  width: 100%;
  margin: 30px 0px;
  display: flex;
  flex-direction: column;

  ${media.lessThan('large')`
    padding: 0px 30px;
  `}
`

export const QuestionTitle = styled.div`
  ${({ theme }) => css`
    width: 100%;
    font-size: ${theme.font.sizes.normal};
    font-family: ${theme.font.montserrat};
    font-weight: ${theme.font.xbold};
    color: ${theme.colors.lightBlue};
    border-bottom: 1px solid ${theme.colors.xlightGray};
    padding: 12px 0px;
  `}
`

export const QuestionsContainer = styled.div`
  width: 100%;
  max-width: 1284px;
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.3rem 1.8rem;

  ${media.lessThan('large')`
    grid-template-columns: 1fr;
  `}
`
